module.exports = __webpack_public_path__ + "static/media/covid-19.6001db85.gif";